module.exports = __webpack_public_path__ + "img/coupon-type-selected-bg-1.305f3b8d.png";